import React from 'react';
import type { ConditionStatus } from '../../types/conditions';

/** Subtle tinted pills in the Mortgage Depot palette. */
export const statusStyles: Record<ConditionStatus, {
  label: string;
  badge: string;
  dot: string;
}> = {
  none: {
    label: 'None',
    badge: 'bg-slate-100 text-slate-600',
    dot: 'bg-slate-400'
  },
  new: {
    label: 'New',
    badge: 'bg-slate-100 text-charcoal',
    dot: 'bg-charcoal'
  },
  requested: {
    label: 'Requested',
    badge: 'bg-brand/10 text-brand-dark',
    dot: 'bg-brand'
  },
  review: {
    label: 'Review',
    badge: 'bg-amber-50 text-amber-800',
    dot: 'bg-amber-500'
  },
  cleared: {
    label: 'Cleared',
    badge: 'bg-steel-light text-steel-dark',
    dot: 'bg-steel'
  },
  waived: {
    label: 'Waived',
    badge: 'bg-slate-100 text-slate-600',
    dot: 'bg-slate-500'
  }
};
interface StatusBadgeProps {
  status: ConditionStatus;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const s = statusStyles[status];
  return <span className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium ${s.badge}`} data-id="element-348" data-mp="2tw2lpog9ht12">
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} aria-hidden="true" data-id="element-349" data-mp="rdyr5g9o1dxd" />
      {s.label}
    </span>;
}